import { MediaQueries, theme } from '@hhgtech/hhg-components'
import { BadgeProps, Carousel } from '@hhgtech/hhg-components/mantine'
import styled from 'styled-components'

export const EmotionBadge = {
  root: {
    background: '#ffffff',
    borderRadius: '32px',
    padding: '5px 12px',
    textTransform: 'unset',
    height: 'auto',
  },
} as BadgeProps['styles']

export const StyledTopicScrollList = styled.div`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
`

export const StyledPost = styled.div`
  .header {
    width: 100%;
    display: flex;
    gap: 16px;

    .detail {
      width: 100%;
      flex-grow: 1;
      gap: 4px;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      &-author {
        display: flex;
        gap: 4px;
        align-items: center;
      }
      button {
        width: fit-content;
        text-align: left;
      }
    }
  }
  .content {
    margin-top: 8px;
    margin-bottom: 16px;

    a {
      color: ${theme.mbColors.lightPink};
    }

    mention {
      /* color: ${theme.mbColors.dark}; */
      padding-right: 4px;
      &:first-child ~ * {
        &:not(ul),
        &:not(ol) {
          display: inline-block;
        }
      }
      &:first-child {
        margin-right: 5px;
      }
      /* &:hover {
        text-decoration: underline;
      } */
    }
  }

  .action {
    display: flex;
    gap: 24px;
    align-items: center;
    justify-content: end;
    > * {
      display: flex;
      gap: 8px;
      align-items: center;
      justify-content: end;
    }
  }
  a {
    text-decoration: none;
  }

  .mantine-Spoiler-control {
    text-align: left;
    p {
      font-size: 14px;
      line-height: 24px;
      letter-spacing: -0.2px;
      color: #e55c8a;
    }
    &:hover {
      text-decoration: none;
    }
  }
`

export const StyledCarousel = styled(Carousel)`
  cursor: grab;
  ${MediaQueries.mbDown} {
    width: 100%;
  }
  .mantine-Carousel-control {
    &[data-inactive] {
      opacity: 0;
      cursor: default;
    }
    background-color: #ffffff;
    opacity: 1;
  }
  .mantine-Carousel-viewport {
    width: calc(100% - 36px);
  }
  .mantine-Carousel-controls {
  }
`
